import type { BeneficiaryAgencyScope } from '@UI/Pages/Beneficiaries/BeneficiaryList/Filters/BeneficiaryAgencyScope';

const resolveAgencyScopeKey = (scope: BeneficiaryAgencyScope): string => {
	switch (scope.type) {
		case 'all':
			return 'all';
		case 'organization':
			return `organization:${scope.organizationId}`;
		case 'facility':
			return `facility:${scope.facilityId}`;
	}
};

export default resolveAgencyScopeKey;
